import React from "react";
import { Row, Col, Button, Layout } from "@folio/stripes/components";
import { useIntl } from "react-intl";
export var ExpandCollapseToggle = function (_a) {
    var expanded = _a.expanded, onToggle = _a.onToggle;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: 12 },
            React.createElement(Layout, { className: "display-flex justify-end" },
                React.createElement(Button, { onClick: onToggle, buttonStyle: "default" }, expanded
                    ? formatMessage({ id: "ui-br-legaldeposits.button.collapse" })
                    : formatMessage({ id: "ui-br-legaldeposits.button.expand" }))))));
};
